/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Modal_Maxrequired5Inputs */

const en_coinvestments_gpestimatedticketsize_modal_maxrequired5 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Modal_Maxrequired5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum ticket size is required`)
};

/**
* | output |
* | --- |
* | "Maximum ticket size is required" |
*
* @param {Coinvestments_Gpestimatedticketsize_Modal_Maxrequired5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_modal_maxrequired5 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Modal_Maxrequired5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Modal_Maxrequired5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_modal_maxrequired5(inputs)
});
export { coinvestments_gpestimatedticketsize_modal_maxrequired5 as "coInvestments_gpEstimatedTicketSize_modal_maxRequired" }